var map = {
	"./innovation-radar-data": [
		9039,
		[]
	],
	"./innovation-radar-data.json": [
		9039,
		[]
	],
	"./navigationStructure": [
		5409,
		[]
	],
	"./navigationStructure.json": [
		5409,
		[]
	],
	"./settings": [
		9727,
		[
			727
		]
	],
	"./settings.json": [
		9727,
		[
			727
		]
	],
	"./timeline": [
		7317,
		[]
	],
	"./timeline.json": [
		7317,
		[]
	],
	"./videoGallery": [
		7173,
		[
			173
		]
	],
	"./videoGallery.json": [
		7173,
		[
			173
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8782;
module.exports = webpackAsyncContext;